import React, { FormEvent, useContext, useEffect } from "react";
import EmployeeStore from "../../../app/stores/employeeStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import {
  Grid,
  Segment,
  Dropdown,
  Search,
  Button,
  Input,
  Form,
  Select,
} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import EmployeeList from "./EmployeeList";
import { useState } from "react";

const EmployeeDashboard: React.FC = () => {
  const employeeStore = useContext(EmployeeStore);
  const { loadJobPositions, searchEmployee, selectEmployeeStatus, loadEmployees} = employeeStore;
 
  const [term, setTerm] = useState("");

  const handleInputChange=(event: FormEvent<HTMLInputElement>) => {
    const {value} = event.currentTarget;
    setTerm(value);
    searchEmployee(event.currentTarget.value);
  }

  useEffect(() => {
    loadEmployees();
    loadJobPositions();
  }, [employeeStore]);

  const statusOptions = [
    { key: "Employee", text: "Employee", value: "Employee" },
    { key: "Subcontractor", text: "Subcontractor", value: "Subcontractor" },
    { key: "Inactive", text: "Inactive", value: "Inactive" },
    { key: "Resigned", text: "Resigned", value: "Resigned" },
    { key: "Blacklist", text: "Blacklist", value: "Blacklist" },
  ];

  if (employeeStore.loadingInitial) return <LoadingComponent content="Loading employees" />;

  return (
    <Segment>
      <Grid>
      <Grid.Column textAlign="left" width={4}>
          <Input  type="text" icon="search" placeholder="Search technician" onChange={handleInputChange} value={term}/>
        </Grid.Column>
        <Grid.Column textAlign="left" width={8}>
          <Select 
            placeholder="Select Employee Status" 
            options={statusOptions}
            onChange={(e, { value }) =>
              selectEmployeeStatus(value!.toString())
            }
            clearable
          />
        </Grid.Column>
        <Grid.Column textAlign="center" width={3}>
          <Button
            color="linkedin"
            as={Link}
            to={`/hrmanagement/employees-create`}
            icon="add"
            content="Create New"
          />
        </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column>
          <EmployeeList />
        </Grid.Column>
      </Grid>
    </Segment>
  );
};

export default observer(EmployeeDashboard);
